import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=06b0f5e6&"
import script from "./Edition.vue?vue&type=script&lang=js&"
export * from "./Edition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports